import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';

/** FixedCostsPanel header's Edit/Cancel+Save button group, split into its own file so
 * the panel's own JSX stays shallow. */
export default function FixedCostsHeaderActions({
	editing,
	saving,
	canSave,
	costFrozen,
	onCancel,
	onSave,
	onStartEdit,
}) {
	if (!editing) {
		return (
			<Tooltip title={costFrozen ? 'Cost is frozen — no further entries' : undefined}>
				<Button icon={<EditOutlined />} disabled={costFrozen} onClick={onStartEdit}>
					Edit
				</Button>
			</Tooltip>
		);
	}
	return (
		<>
			<Button onClick={onCancel} disabled={saving}>
				Cancel
			</Button>
			<Button type="primary" loading={saving} disabled={!canSave} onClick={onSave}>
				Save
			</Button>
		</>
	);
}

FixedCostsHeaderActions.propTypes = {
	editing: PropTypes.bool.isRequired,
	saving: PropTypes.bool.isRequired,
	canSave: PropTypes.bool.isRequired,
	costFrozen: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	onStartEdit: PropTypes.func.isRequired,
};
